export default {"src":"/_next/static/media/earth-globe-white.084603ca.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};